export default __webpack_public_path__ + "static/media/login_logo.05d53f82.png";